<template>
  <div class="container">
    <!-- 首页导航模块 -->
    <!-- <homenav></homenav> -->
    <!-- 首页轮播图模块 -->
    <homemain :itemdata="carousel" @indexgoto="indexgoto"></homemain>
    <!-- <ul class="side-bar" ref="sidebar">
      <li
        :class="index == activeIndex ? 'active' : ''"
        v-for="(item, index) in floorList"
        @click="scrollTo(index)"
        :key="item.title"
      >
        {{ item.title }}
      </li>
    </ul> -->
    <div class="tool-box c-pointer" ref="toolBox">
      <!-- <div
        class="shoppinglist"
        @click="topage(1)"
        v-if="dhtx && $store.state.hasLogin"
      >
        <img :src="require('@/assets/images/icon_dh.png')" alt="" />
      </div> -->
      <!-- <div class="qrcode">
        <el-popover placement="right" width="188" trigger="hover">
          <div class="qrcode-box">
            <div class="qrcode-item">
              <div class="qrcode-img">
                <img
                  :src="require('@/assets/images/logo/app_ewm.png')"
                  alt=""
                />
              </div>
              <p>APP购药</p>
            </div>
            <div class="qrcode-item">
              <div class="qrcode-img">
                <img :src="require('@/assets/images/logo/vx_ewm.png')" alt="" />
              </div>
              <p>微信购药</p>
            </div>
          </div>
          <img
            slot="reference"
            :src="require('@/assets/images/icon_qrcode.png')"
            alt=""
          />
        </el-popover>
      </div> -->
      <!-- <div class="shoppinglist" @click="topage(2)" v-if="$store.state.hasLogin">
        <img :src="require('@/assets/images/cgqd(1).png')" alt="" />
      </div>
      <div class="sm" @click="topage(3)" v-if="$store.state.hasLogin && showSm">
        <img :src="require('@/assets/images/x_smtj.png')" alt="" />
      </div> -->
      <div
        ref="scroll_bar"
        class="backtop"
        @click="scrollTo"
        v-if="backTopIsShow"
      >
        <img :src="require('@/assets/images/icon_top.png')" alt="" />
      </div>
    </div>
    <!-- 楼层区域制作-->
    <div class="con floor">
      <!-- 每日上新楼层 -->
      <!-- <homefloor1 title="每日上新" ref="floor1"></homefloor1> -->
      <!-- 促销活动楼层 -->
      <!-- <homefloor2></homefloor2> -->
      <!-- 中药新品 -->
     <!--  <homefloor1
        :floorLists="floorList"
        ref="homefloor1"
        @indexgoto="indexgoto"
      ></homefloor1> -->
      <!-- 中药促销 -->
      <!-- <homefloor1 title="中药促销"></homefloor1> -->
      <!-- 特卖商品 -->
      <!-- <homefloor3></homefloor3> -->
      <!-- 热门牌子 -->
    </div>
    <popup
      class="popup-info"
      width="350px"
      height="200px"
      @close="closemm"
      v-if="show"
    >
      <div class="safe-box">
        <img
          class="close"
          :src="require('@/assets/images/x.png')"
          alt=""
          @click="closemm"
        />
        <div class="title">
          尊敬的客户： 您的密码设置过于简单，为保障您的交易安全，请重新设置。
        </div>
        <div class="btn">
          <span class="span1" @click="confirm">确定</span>
          <span class="span2" @click="closemm">取消</span>
        </div>
      </div>
    </popup>
    <popup
      class="popup-info"
      width="360px"
      height="500px"
      @close="close"
      v-if="showdhtx"
    >
      <div class="dhtx-box">
        <div class="dh">
          <div class="dh-btn c-pointer" @click="topage(1)">
            <img src="../../../assets/images/an.png" alt="" />
          </div>
        </div>
        <div class="title hdx">
          <img
            :src="require('@/assets/images/hdx.png')"
            alt=""
            @click="close"
          />
        </div>
      </div>
    </popup>
    <smActivity ref="smAct"></smActivity>
  </div>
</template>

<script>
// import search from "@/components/search.vue";
// import homenav from "./components/home-nav";
import homemain from "./components/home-main";
import homefloor1 from "./components/home-floor1";
import homebrand from "./components/home-brand";
import homeDialog from "./components/home-dialog";
import { mapState } from "vuex";

export default {
  components: {
    homeDialog,
    homemain,
    homefloor1,
    homebrand
  },
  data() {
    return {
      dialogVisible: false,
      alertScreen: {
        content: "",
        id: 99,
        image: "",
        isnb: true,
        title: "",
        type: 5
      },
      carousel: [],
      floorList: [],
      //   noticeList:[],
      brandsList: [],
      activeIndex: 0,
      backTopIsShow: false,
      show: false,
      showdhtx: false,
      dhtx: "",
      showSm: false
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {
    this.getHomeList();
    this.getReplenish();
    this.screen();
    //this.getNoticeList()
    //this.userInfo.passwordSimple
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollx);
    console.log(this.dhtx, this.userInfo.passwordSimple);

    let nowData = new Date().toLocaleDateString();
    let active = JSON.parse(localStorage.getItem("smActivity"));
    let time = nowData == localStorage.getItem("startTime");
    if (active && time) {
      this.showSm = true;
      return;
    } else {
      this.$api.POST_SECRETACTIVITY().then(res => {
        if (res.data.opened) {
          let startDate = new Date().toLocaleDateString();
          // console.log(myDate.getTime());
          localStorage.setItem("smActivity", true);
          localStorage.setItem("activityId", res.data.special.id);
          localStorage.setItem("startTime", startDate);
          this.showSm = true;
          this.$refs.smAct.showdhtx = true;
        } else {
          localStorage.setItem("smActivity", false);
        }
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx);
  },

  methods: {
    isCurrentDay(time) {
      if (new Date(Number(time)).toDateString() === new Date().toDateString()) {
        return true;
        //当天
      } else if (new Date(this.PostTime) < new Date()) {
        //非当天
        return false;
      }
    },
    //获取弹框并缓存
    screen() {
      this.$api.GET_ALERTSCREEN().then(res => {
        let hasScreen = false;
        let currentScreen;
        if (res.status && res.data.exists) {
          if (this.hasScreen()) {
            hasScreen = true;
            currentScreen = this.hasScreen();
          }
          if (hasScreen) {
            let id = currentScreen.split("_")[2];
            let time = currentScreen.split("_")[1];
            if (id == res.data.alertScreen.id) {
              if (this.isCurrentDay(time)) {
                //如果是当天，弹框对象不需要重置,并显示弹框
                if (JSON.parse(localStorage[currentScreen]).isnb) {
                  this.alertScreen = JSON.parse(localStorage[currentScreen]);
                  this.dialogVisible = true;
                }
              } else {
                //不是当天，删除之前screen对象,需要重新定义缓存弹框名字并重新存储新的对象，显示弹框
                localStorage.removeItem(this.hasScreen());
                this.setScreen(res.data.alertScreen);
              }
            } else {
              localStorage.removeItem(this.hasScreen());
              this.setScreen(res.data.alertScreen);
            }
          } else {
            this.setScreen(res.data.alertScreen);
          }
        }
      });
    },
    //是否有缓存弹框
    hasScreen() {
      for (let prop in localStorage) {
        if (prop.indexOf("screen") !== -1) {
          return prop;
        }
      }
    },

    // 弹窗缓存
    setScreen(alertScreen) {
      this.alertScreen = { ...alertScreen };
      this.dialogVisible = true;
      window.localStorage.setItem(
        `screen_${new Date().getTime()}_${alertScreen.id}`,
        JSON.stringify(alertScreen)
      );
    },
    //修改弹框isnb
    changeScreen(isnb) {
      this.alertScreen.isnb = isnb;
      for (let prop in localStorage) {
        if (prop.indexOf("screen") !== -1) {
          let data = JSON.parse(localStorage[prop]);
          data.isnb = isnb;
          localStorage[prop] = JSON.stringify(data);
        }
      }
    },
    indexgoto(item) {
      /*
          none(0, "无链接"),
          goods_detail(1, "商品详情"),
          goods_keyword(2, "商品关键字"),
          combination_detail(3, "套餐详情"),
          combination_tag(4, "套餐标签"),
          special(5, "限时特价"),
          article(6, "文章");
          brand(8,商业品牌)
          cate(9,商品分类)
        */

      if (item.type == 1) {
        this.$router.push({
          name: "detail",
          query: { goodsId: item.content, type: 1 }
        });
      } else if (item.type == 2) {
        // this.$store.commit('GET_GOODSLIST',item.content)
        this.$router.push({ name: "search", query: { keyword: item.content } });
      } else if (item.type == 3) {
        this.$router.push({
          name: "detail",
          query: { goodsId: item.content, type: 2 }
        });
      } else if (item.type == 4) {
        this.$router.push({ name: "search", query: { tagId: item.content } });
      } else if (item.type == 5) {
        this.$router.push({ name: "bargain", query: { Id: item.content } });
      } else if (item.type == 6) {
        this.$router.push({ name: "helpcenter", query: { id: item.content } });
      } else if (item.type == 7) {
        this.$router.push({ name: "home" });
      } else if (item.type == 8) {
        this.$router.push({ name: "search", query: { brandId: item.content } });
      } else if (item.type == 9) {
        this.$store.commit("GET_GOODSLIST", "");
        this.$router.push({ name: "search", query: { id: item.content } });
      } else if (item.type == 10) {
        this.$router.push({ name: "bargain" });
      } else if (item.type == 11) {
        this.$router.push({ name: "getcoupon" });
      } else if (item.type == 12) {
        this.$router.push({ name: "activities" });
      } else if (item.type == 13) {
        this.$router.push({
          name: "subjectDetail",
          query: { id: item.content }
        });
      }
    },
    search(res) {
      this.$router.push({ name: "search" });
    },
    handleScrollx() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      scrollTop > 150
        ? (this.backTopIsShow = true)
        : (this.backTopIsShow = false);
      // console.log(scrollTop);
      if (scrollTop < 750) {
        this.activeIndex = 0;
        this.$refs.sidebar.style.position = "absolute";
        this.$refs.sidebar.style.top = "612px";
        this.$refs.toolBox.style.position = "absolute";
        this.$refs.toolBox.style.top = "612px";
      } else {
        this.$refs.sidebar.style.position = "fixed";
        this.$refs.sidebar.style.top = "70px";
        this.$refs.toolBox.style.position = "fixed";
        this.$refs.toolBox.style.top = "70px";
        if (scrollTop >= 1330 && scrollTop < 1950) {
          this.activeIndex = 1;
        } else if (scrollTop >= 1950 && scrollTop < 2550) {
          this.activeIndex = 2;
        } else if (scrollTop >= 2550) {
          this.activeIndex = 3;
        }
      }
    },
    getHomeList() {
      this.$api.POST_HOMELIST().then(res => {
        if (res.status) {
          // this.carousel = res.data.slideshows;
          this.carousel = [
            {
              content: "苗骨康",
              image:
                "http://image.dgsjyyy.com/jinyuan/20240612/15030b6e267c4a8cbc57a3050038ecc2.jpg",
              type: 2
            }
          ];
          this.floorList = res.data.positions;
          this.brandsList = res.data.hotBrands;
        }
      });
    },

    scrollTo(index) {
      let scrollTo;
      switch (index) {
        case 0:
          scrollTo = 740;
          // this.scrollTarget(740,'location')
          break;
        case 1:
          // this.scrollTarget(1400,'location')
          scrollTo = 1330;
          break;
        case 2:
          // this.scrollTarget(2010,'location')
          scrollTo = 1950;
          break;
        case 3:
          // this.scrollTarget(2610,'location')
          scrollTo = 2550;
          break;
        default:
          scrollTo = 0;
          break;
      }
      window.scrollTo({
        top: scrollTo,
        behavior: "smooth"
      });
    },
    close() {
      this.showdhtx = false;
      //   console.log(this.userInfo.passwordSimple,'2222222222222222222222222222222222222222222')
      if (this.userInfo.passwordSimple) {
        this.show = true;
      }
    },
    closemm() {
      this.show = false;
    },
    confirm() {
      this.show = false;
      this.$router.push({ path: "/person/center", query: { isShow: true } });
    },
    topage(type) {
      if (type == 1) {
        this.$router.push({ name: "replenishList" });
      } else if (type == 2) {
        this.$router.push({ name: "shoppinglist" });
      } else if (type == 3) {
        this.$router.push({ name: "smActivityList" });
      }
    },
    //是否有预购商品到货
    async getReplenish() {
      // 是否到货提醒
      let isReplenish = sessionStorage.getItem("isReplenish");
      if (isReplenish == null) {
        await this.$api.GET_SUBSCRIBEREPLENISH().then(res => {
          if (res.status) {
            this.dhtx = res.data;
            sessionStorage.setItem("isReplenish", res.data);
            if (res.data) {
              this.showdhtx = true;
            }
          }
        });
      } else {
        this.dhtx = JSON.parse(isReplenish);
      }
      if (this.userInfo.passwordSimple && !this.showdhtx) {
        this.show = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #fafafa;
  position: relative;
}
.side-bar {
  position: absolute;
  padding-right: 20px;
  width: 64px;
  top: 612px;
  left: 50%;
  margin-left: -684px;
  li {
    width: 44px;
    height: 50px;
    margin-bottom: 4px;
    font-size: 12px;
    color: #999999;
    background-color: #ffffff;
    text-align: center;
    padding: 10px 5px;
    border: 2px solid #fafafa;
    cursor: pointer;
  }
  .active {
    color: #ffffff;
    font-size: 13px;
    background-color: #fa5555;
    background: linear-gradient(red, #fa5555);
  }
}
.side-bar_fix {
  position: fixed;
  top: 50px;
}
.tool-box {
  position: absolute;
  top: 612px;
  right: 50%;
  margin-right: -684px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-bottom: 12px;
  }
}
.qrcode-box {
  .qrcode-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 24px 0 16px 0;
    .qrcode-img {
      margin-bottom: 12px;
      img {
        width: 130px;
        height: 130px;
      }
    }
    p {
      font-size: 14px;
      color: #808080;
    }
  }
}
.floor {
  overflow: hidden;
}
.popup-info {
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 20px;
    padding: 0px 30px;
    line-height: 23px;
  }
  .btn {
    text-align: center;
    span {
      @include btn(124px, 44px, #fa4b4b, #ffffff, 16px, 2px);
    }
    .span2 {
      border: 1px solid #fa4b4b;
      color: #fa4b4b;
      background: none;
      margin-left: 20px;
    }
  }
  .close {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
.safe-box {
  background-color: #ffffff;
  border-radius: 10px;
  padding-bottom: 20px;
}
.dhtx-box {
  @include flex-d-c;
  .dh {
    width: 360px;
    height: 500px;
    background: url("../../../../src/assets/images/yg.png") no-repeat;
    background-size: 100%;
    position: relative;
  }
}
.dh-btn {
  width: 100%;
  position: absolute;
  bottom: 0;
  img {
    width: 100%;
  }
}
.hdx {
  margin-top: 30px !important;
}
/deep/ .popup-container .modal {
  background-color: transparent !important;
}
.sm {
  width: 44px;
  height: 44px;
  margin-bottom: 12px;
  img {
    @include size(100%, 100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/home/index.vue